// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('travelWageMenu', {
//         templateUrl: 'views/components/views/travelWageMenu/travelWageMenu.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'travelWageMenuService', 'layoutService', function ($stateParams, stateService, modalService, translateService, travelWageMenuService, layoutService) {
            
//             // #region VARIABLES & DEFINITIONS
            
//             const vm = this;
//             let travelWageId = $stateParams.travelwage_id;

//             let translations = {
//                 confirm_title: '',
//                 confirm_message: '',
//                 confirm_ok_label: '',
//                 confirm_cancel_label: '',
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 tabletSize: layoutService.getMediaQueries().tablet,
//                 menu: {},
//                 lockedDelete: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION SERVICE

//             // #region LOAD PROCEDURE CALLS

//             async function loadMenu() {
//                 vm.model.menu = (await travelWageMenuService.getTravelWageMenu({ travelwage_id: travelWageId }))[0];
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//             vm.deleteValues = function () {
//                 vm.model.lockedDelete = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(() => {
//                     travelWageMenuService.deleteItem(vm.model.menu).then((response) => {
//                         if (response[0] && response[0].errorcode !== '0') {
//                         	modalService.show({
//                         		type: 'warning',
//                         		title: translations.error,
//                         		message: response[0].errormessage,
//                         		buttons: [{
//                         			label: translations.ok,
//                         			cssClass: 'btn-warning',
//                         			action: (dialogItself) => {
//                         				dialogItself.close();
//                         				vm.model.lockedDelete = false;
//                         			}
//                         		}]
//                         	});
//                         } else {
//                         	vm.model.lockedDelete = false;
//                         	stateService.back();
//                         }
//                     }, () => {
//                         vm.model.lockedDelete = false;
//                     });
//                 }, () => {
//                     vm.model.lockedDelete = false;
//                 });
//             };

//             // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 translate();
//                 loadMenu();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
